import axios from 'axios'
import type { config } from '../types/types'

const baseurl = `${import.meta.env.VITE_APP_PROTOCOL}://${import.meta.env.VITE_API_HOST}:${import.meta.env.VITE_API_PORT}/${import.meta.env.VITE_API_SUBPATH}`
const url = 'user'


export const readUserListAPI = async () => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'list',
    },
  })
  console.log("readUserListAPI 응답:", response.data)
  return response.data.data
}

export const addUserAPI = async (account: string, password: string, description: string, role: number, config: config) => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'add',
      account: account,
      password: password,
      description: description,
      role: role,
      config: btoa(JSON.stringify(config))
    },
  })
  console.log("addUserAPI 응답:", response.data)
  return response.data.data
}

export const deleteUserAPI = async (account: string) => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'delete',
      account: account
    },
  })
  console.log("deleteUserAPI 응답:", response.data)
  return response.data.data
}

export const updateUserAPI = async (existingaccount: string, account: string, password: string, description: string, role: number) => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'update',
      existingaccount: existingaccount,
      account: account,
      password: password,
      description: description,
      role: role
    },
  })
  console.log("updateUserAPI 응답:", response.data)
  return response.data.data
}


export const updateConfigAPI = async (account: string, config: config) => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'configupdate',
      account: account,
      config: btoa(JSON.stringify(config))
    },
  })
  console.log("updateConfigAPI 응답:", response.data)
  return response.data.data
}